import { useMemo } from 'react';

import { getSupabase } from '../api/api';

function useSupabase() {
  return useMemo(getSupabase, []);
}

export default useSupabase;
